import cn from "classnames";
import { t } from "i18next";
import moment from "moment";

import { ResellerCommissionSource } from "../../../constants";
import { ResellerCommission } from "../../../resellers.types";

import styles from "../ResellerCommissionsTable.module.scss";

/**
 * The two ways an influencer earns, and they are not interchangeable:
 * a referral pays because the buyer belongs to the influencer for life,
 * a promo code pays because it was typed at checkout on this one order.
 */
const CommissionSourceCell = ({
  commission
}: {
  commission: ResellerCommission;
}) => {
  const { source, origin } = commission;
  const isReferral = source === ResellerCommissionSource.Referral;

  const formatDate = (date?: string | null) =>
    date ? moment(date).format("DD/MM/YYYY") : "—";

  return (
    <div className={styles.sourceCell}>
      <span
        className={cn(styles.sourceCell_badge, {
          [styles.sourceCell_badge__referral]: isReferral,
          [styles.sourceCell_badge__promoCode]: !isReferral
        })}
      >
        {isReferral ? t("Referee") : t("Promo Code")}
      </span>

      <span className={styles.sourceCell_origin}>
        {isReferral
          ? `${t("Signed up with")} ${origin?.code ?? "—"} · ${formatDate(origin?.signedUpAt)}`
          : `${origin?.code ?? "—"} · ${t("customer since")} ${formatDate(origin?.customerSince)}`}
      </span>
    </div>
  );
};

export default CommissionSourceCell;
